import { Injury, InjuryEnum } from '#fysio/core/enums/InjuryEnum';

export const getFeaturedInjuries = (): {
	title: string;
	injury: Injury;
	text: string;
}[] => {
	return [
		{
			title: 'Last van je heup?',
			text: 'Last van heupklachten? Denk aan pijn in de lies, stijfheid, moeite met lopen of klachten bij sporten. Wij helpen je gericht en persoonlijk.',
			injury: Injury.init(InjuryEnum.HipPain),
		},
		{
			title: 'Pijn in je knie?',
			text: 'Last van knieklachten? We gaan kijken naar de oorzaak en doen er alles aan om jou weer zo snel mogelijk op de been te krijgen.',
			injury: Injury.init(InjuryEnum.KneePain),
		},
		{
			title: 'Last van je rug?',
			text: 'Last van rugklachten? Wij helpen je er vanaf zodat je beter gaat bewegen dan je gewend bent.',
			injury: Injury.init(InjuryEnum.BackPain),
		},
	];
};
